export function formatDate(date) {
    let dateFormat = date.split('T')[0].split('-');
    dateFormat = `${dateFormat[2]}/${dateFormat[1]}/${dateFormat[0]}`;
    return dateFormat; 
}